import type { Reservation } from '../models/equipment.models';

/** User-facing reservation status (DB "completed" = paid, waiting to issue). */
export function reservationStatusLabel(status: Reservation['status']): string {
  switch (status) {
    case 'completed':
      return 'Ready to issue';
    case 'issued':
      return 'Issued out';
    case 'confirmed':
      return 'Confirmed';
    case 'pending':
      return 'Pending';
    case 'cancelled':
      return 'Cancelled';
    default:
      return status;
  }
}

export const EQUIPMENT_RENTAL_FLOW =
  'Book on Reservations → mark Ready to issue when paid → Issue equipment on Check-Out → status becomes Issued out → Return on Check-In. Overdue and Damaged are separate follow-up lists.';
